import React from 'react'
import styled from '@emotion/styled'
import { Button, color } from 'stylist'

export const PrimaryButton = styled(({ children, ...props }) => (
  <Button {...props} kind="primary">
    {children}
  </Button>
))`
  &,
  &:focus {
    background-color: ${color('slate')};
    color: ${color('white')};
    border-color: transparent;
  }

  &:hover:not([disabled]) {
    background-color: ${color('pewter')};
    border-color: transparent;
  }
`



// WEBPACK FOOTER //
// ./src/components/Button.js